<template>
  <div>
    <QS-h4-title title="应收业务信息" />
    <el-form label-width="140px">
      <column-box
        :source="source"
        :list="list"
        :column="3"
        :label-width="130"
      >
      </column-box>
    </el-form>
  </div>
</template>

<script>
import selectOption from '@/store/dict/selectOptionDict'

export default {
  props: {
    source: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    source: {
      handler(val) {
        this.source.sourceOrderTypeName = selectOption.sourceOrderTypeDict[val.sourceOrderType]
      },
      deep: true,
    },
  },
  data() {
    return {
      list: [
        {
          key: 'sourceOrderId',
          name: '来源单ID',
        },
        {
          key: 'sourceOrderTypeName',
          name: '来源类型',
        },
        {
          key: 'relReceivableId',
          name: '关联单ID',
        },
        {
          key: 'plateNo',
          name: '车牌号',
        },
        {
          key: 'customer',
          name: '付款方',
        },
        {
          key: 'customerId',
          name: '付款方ID',
        },
      ],
    }
  },
  created() {
    this.source.sourceOrderTypeName = selectOption.sourceOrderTypeDict[this.source.sourceOrderType]
  },
}
</script>

<style>

</style>
